module.exports = __webpack_public_path__ + "static/media/email-opened-white.879bf9e9.svg";